import { ACTION_TYPES } from '../../constants/store.constants';

const initialState = {
  type: null,
  email: null,
  mobile: null,
  multiGuestInvitees: [],
  multiInviteTrackingDetails: null,
  multiGuestPatientInvitees: [],
  multiInviteTrackingDetailsLastSuccessful: []
};

const GuestReducer = (state, { type, payload } = {}) => {
  if (!state) state = initialState;
  switch (type) {
    case ACTION_TYPES.SET_GUEST_INVITE_TYPE:
      return {
        ...state,
        type: payload
      };
    case ACTION_TYPES.SET_GUEST_INVITE_EMAIL:
      return {
        ...state,
        email: payload
      };
    case ACTION_TYPES.SET_GUEST_INVITE_MOBILE:
      return {
        ...state,
        mobile: payload
      };
    case ACTION_TYPES.SET_MULTI_GUEST_INVITEES:
      return {
        ...state,
        multiGuestInvitees: payload
      };
    case ACTION_TYPES.SET_MULTI_INVITE_TRACKING_DETAILS:
      return {
        ...state,
        multiInviteTrackingDetails: payload
      };
    case ACTION_TYPES.CLEAR_MULTI_INVITE_TRACKING_DETAILS:
      return {
        ...state,
        multiInviteTrackingDetails: null
      };

    case ACTION_TYPES.SET_MULTI_GUEST_PATIENT_INVITEES:
      return {
        ...state,
        multiGuestPatientInvitees: payload
      };

    case ACTION_TYPES.LAST_SUCCESSFUL_MULTI_INVITE_TRACKING_DETAILS:
      return {
        ...state,
        multiInviteTrackingDetailsLastSuccessful: payload
      };
    default:
      return state;
  }
};

export default GuestReducer;
